import { LoadingOverlay } from '@eventbrite/eds-loading-overlay';
import React from 'react';
import './FullPageLoadingLayer.scss';

export type ExpressCheckoutLoadingLayerProps = {
    isShown?: boolean;
};

export const FullPageLoadingLayer: React.FC<
    ExpressCheckoutLoadingLayerProps
> = ({ isShown = false }) => (
    <div className="full-page-loading-layer">
        <LoadingOverlay isShown={isShown} />
    </div>
);
